import React from 'react'

export default function SaveIcon({className = "w-6"}) {
    return (
        <svg className={className} viewBox="0 0 24 24">
            <path d="M5 21h14a2 2 0 0 0 2-2V8l-5-5H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zM7 5h4v2h2V5h2v4H7V5zm0 8h10v6H7v-6z"></path>
        </svg>
    )
}
